import React, { useState, useEffect } from "react";

interface RadioProps {
  onRampLabel: string;
  offRampLabel: string;
  onChange: (option: string) => void;
}

const CustomRadioButton: React.FC<RadioProps> = ({
  onRampLabel,
  offRampLabel,
  onChange,
}) => {
  const [selectedOption, setSelectedOption] = useState("onRamp");

  useEffect(() => {

    setSelectedOption("onRamp");
  }, []);

  const handleOptionChange = (option: string) => {
    // const option = event.target.value;
    // setSelectedOption(option);
    onChange(option);
  };

  return (
    <div className={` flex items-center justify-between `}>
      <div
        className={`content border  flex items-center justify-center p-4 rounded-md bg-[#F2FAF7] ${
          selectedOption === "onRamp" ? "active" : ""
        }`}
      >
        <div
          className={`radio-button ${
            selectedOption === "onRamp" ? "active" : ""
          }`}
          onClick={() => { setSelectedOption("onRamp");  handleOptionChange(onRampLabel);}}
        >
          <div className="radio-inner"></div>
          <span className="label">{onRampLabel}</span>
        </div>
      </div>

      <div
        className={`content border  flex items-center justify-center p-4 rounded-md bg-[#F2FAF7] ${
          selectedOption === "offRamp" ? "active" : ""
        }`}
      >
        <div
          className={`radio-button ${
            selectedOption === "offRamp" ? "active" : ""
          }`}
          onClick={() => { setSelectedOption("offRamp"); handleOptionChange(offRampLabel);}}
        >
          <div className="radio-inner"></div>
          <span className="label">{offRampLabel}</span>
        </div>
      </div>
    </div>
  );
};

export default CustomRadioButton;
